const IS_PRODUCTION = (process.env.REACT_APP_IS_PRODUCTION || 'false').toLowerCase() === 'true'

export const BROADSIDER_COLLECTION_URL = IS_PRODUCTION
  ? 'https://opensea.io/collection/basejump-actionfigures'
  : 'https://testnets.opensea.io/collection/basejump-actionfigures';

export const NOT_A_REAL_ID = '0x0000000000000000000000000000000000000000';
export const BROADSIDER_OG_CONTRACT_ADDRESS = '0xe3589AE55BbD7697C76c510a5335eB31d972A17E';
export const BROADSIDER_OG_COLLECTION_URL = 'https://opensea.io/collection/broadside';
export const MUTATIO_CONTRACT_ADDRESS = '0xfdb192fb0213d48ecdf580c1821008d8c46bdbd7';
export const BASEJUMP_CONTRACT_ADDRESS = '0x213ED28190FEdc75Dd25C1B4E46Da85D3F5f0CCB';
export const BASEJUMP_BI_CONTRACT_ADDRESS = '0xf5f37BC5B4b80a9ABA5f01aD4fd98D7b0151bDd4';
export const MAILCHIMP_U = process.env.REACT_APP_MAILCHIMP_U || '6a2e0702c6f63f2e73d696715';
export const MAILCHIMP_ID = process.env.REACT_APP_MAILCHIMP_ID || '8bd6a137bf';
export const MAILCHIMP_URL = process.env.REACT_APP_MAILCHIMP_URL || `https://dazzleship.us3.list-manage.com/subscribe/post?u=${MAILCHIMP_U}&id=${MAILCHIMP_ID}&MMERGE5=BASEJUMP`;
export const INSTAGRAM_FILTER_URL = process.env.REACT_APP_INSTAGRAM_FILTER_URL || 'https://www.instagram.com/ar/790419996292274/?ch=N2VjZWY5OWRkZjhlMzMxZGU0NWVjODY5MDRjZTRmNTA%3D'
